// @ts-strict-ignore
import {Component, ElementRef, Input, OnChanges, OnDestroy, OnInit, SimpleChanges, ViewChild} from "@angular/core";
import {SimUtilityExtendedService} from "@services";
import {EventEmitterService} from "@event-emitter";
import {Media} from "@models";

@Component({
	selector: "sim-video-viewer",
	templateUrl: "./video-viewer.component.html",
	styleUrls: ["./video-viewer.component.scss"],
	providers: [EventEmitterService],
	standalone: false,
})
export class VideoViewerComponent implements OnInit, OnChanges, OnDestroy {
	@Input() media: Media = null;
	@Input() isPlaying = false;
	@Input() isLooping = false;
	@Input() initalPosition: number = 0;
	@Input() volume = 1;

	public mediaUrl: string = null;

	@ViewChild("videoElement") playerRef: ElementRef<HTMLVideoElement>;

	private get player() {
		return this.playerRef?.nativeElement;
	}

	constructor(
		private _simUtilityService: SimUtilityExtendedService,
		private _emitterService: EventEmitterService,
	) {}

	public ngOnInit() {}

	public ngOnDestroy(): void {}

	public async ngOnChanges(changes: SimpleChanges) {
		if (changes["media"] && this.media) {
			this.mediaUrl = this._simUtilityService.getMediaPath(this.media);
		}
		if (changes["initalPosition"]?.firstChange) {
			setTimeout(() => {
				this.player.currentTime = this.initalPosition;
			}, 1);
		}
	}

	public handleTimeUpdate() {
		this._emitterService.onMediaCurrentTimeChanged.next({
			media: this.media,
			currentTime: this.player?.currentTime,
			totalTime: this.player?.duration,
		});
	}

	isValidVolume(volume: number): boolean {
		return typeof volume === "number" && !isNaN(volume) && volume >= 0 && volume <= 1;
	}
}
